import localforage from 'localforage'

// Configuración general
localforage.config({
    name: 'alexdb',
    version: 1.0,
    storeName: 'keyvaluepairs',
    description: 'Almacenamiento offline para Andy App'
})

// Exportar instancias nombradas
export const db_login = localforage.createInstance({ name: 'alexdb', storeName: 'login' })
export const db_updates = localforage.createInstance({ name: 'alexdb', storeName: 'updates' })

export const db_tasks = localforage.createInstance({
    name: 'alexdb',
    storeName: 'tasks'
})
export const db_tasks_queue = localforage.createInstance({
    name: 'alexdb',
    storeName: 'tasks_queue'
})

export const db_audits = localforage.createInstance({
    name: 'alexdb',
    storeName: 'audits'
})
export const db_audits_queue = localforage.createInstance({
    name: 'alexdb',
    storeName: 'audits_queue'
})

export const db_registers_queue = localforage.createInstance({
    name: 'alexdb',
    storeName: 'registers_queue'
})

export const db_issues_queue = localforage.createInstance({
    name: 'alexdb',
    storeName: 'issues_queue'
})

export const db_templates = localforage.createInstance({
    name: 'alexdb',
    storeName: 'templates'
})

export const db_registers = localforage.createInstance({
    name: 'alexdb',
    storeName: 'registers'
})

export const db_registers_schemas = localforage.createInstance({
    name: 'alexdb',
    storeName: 'registers_schemas'
})

export const db_issues = localforage.createInstance({
    name: 'alexdb',
    storeName: 'issues'
})

export const db_timers = localforage.createInstance({
    name: 'alexdb',
    storeName: 'timers'
})

export const db_checks_to_sync = localforage.createInstance({
    name: 'alexdb',
    storeName: 'checks_to_sync'
})

export const db_screenlock = localforage.createInstance({
    name: 'alexdb',
    storeName: 'screenlock'
})

export const db_legal_conditions = localforage.createInstance({ name: 'alexdb', storeName: 'legal_conditions' })
export const dbEmployeeLoginLogs = localforage.createInstance({ name: 'alexdb', storeName: 'employee_login_logs' })
export const db_timezones = localforage.createInstance({ name: 'alexdb', storeName: 'timezones' })
export const db_languages = localforage.createInstance({ name: 'alexdb', storeName: 'languages' })
export const db_employees = localforage.createInstance({ name: 'alexdb', storeName: 'employee' })
export const db_roles = localforage.createInstance({ name: 'alexdb', storeName: 'roles' })
export const db_categories = localforage.createInstance({ name: 'alexdb', storeName: 'product_categories' })
export const db_products = localforage.createInstance({ name: 'alexdb', storeName: 'products' })
export const db_collections = localforage.createInstance({ name: 'alexdb', storeName: 'product_collections' })
export const db_printlogs = localforage.createInstance({ name: 'alexdb', storeName: 'product_printlogs' })
export const db_error_logs = localforage.createInstance({ name: 'alexdb', storeName: 'product_print_error_logs' })
export const db_printlogs_android = localforage.createInstance({ name: 'alexdb', storeName: 'product_printlogs_android' })
export const db_library_categories = localforage.createInstance({
    name: 'alexdb',
    storeName: 'library_categories'
})
export const db_sections = localforage.createInstance({
    name: 'alexdb',
    storeName: 'library_sections'
})
export const db_files = localforage.createInstance({
    name: 'alexdb',
    storeName: 'library_files'
})
export const db_highlight_files = localforage.createInstance({
    name: 'alexdb',
    storeName: 'library_highlight_files'
})
export const db_logbook = localforage.createInstance({ name: 'alexdb', storeName: 'logbook' })
export const db_issues_templates = localforage.createInstance({ name: 'alexdb', storeName: 'issues_templates' })
export const db_locations = localforage.createInstance({ name: 'alexdb', storeName: 'locations' })
export const db_registers_items = localforage.createInstance({ name: 'alexdb', storeName: 'registers_items' })
export const db_audits_items = localforage.createInstance({ name: 'alexdb', storeName: 'audits_items' })
export const db_issues_items = localforage.createInstance({ name: 'alexdb', storeName: 'issues_items' })
export const db_locations_auditor = localforage.createInstance({ name: 'alexdb', storeName: 'db_locations_auditor' })
export const db_notification = localforage.createInstance({ name: 'alexdb', storeName: 'notification' })
export const db_event = localforage.createInstance({ name: 'alexdb', storeName: 'event' })
export const db_timerproducts = localforage.createInstance({ name: 'alexdb', storeName: 'timerproducts' })
export const db_tpcategories = localforage.createInstance({ name: 'alexdb', storeName: 'tp_categories' })
export const db_tpstates = localforage.createInstance({ name: 'alexdb', storeName: 'tp_states' })
export const db_timerlogs = localforage.createInstance({ name: 'alexdb', storeName: 'tp_timerlogs' })
export const db_product_categories = localforage.createInstance({
    name: 'alexdb',
    storeName: 'product_categories'
})

// Función centralizada para limpiar datos
export async function cleanAllStorage() {
    console.warn('INIT - cleanAllStorage')
    try {
        const promises = [db_login.clear(), db_updates.clear(), db_tasks_queue.clear(), db_audits_queue.clear(), db_registers_queue.clear(), db_issues_queue.clear(), db_templates.clear(), db_registers.clear(), db_registers_schemas.clear(), db_issues.clear(), db_timers.clear(), db_checks_to_sync.clear(), db_screenlock.clear(), db_legal_conditions.clear(), dbEmployeeLoginLogs.clear(), db_product_categories.clear(), db_products.clear(), db_collections.clear(), db_printlogs.clear(), db_error_logs.clear(), db_printlogs_android.clear(), db_library_categories.clear(), db_sections.clear(), db_files.clear(), db_highlight_files.clear(), db_logbook.clear(), db_issues_templates.clear(), db_locations.clear(), db_registers_items.clear(), db_audits_items.clear(), db_issues_items.clear(), db_locations_auditor.clear(), db_notification.clear(), db_event.clear(), db_timerproducts.clear(), db_tpcategories.clear(), db_tpstates.clear(), db_timerlogs.clear(), db_tasks.clear(), db_audits.clear()]
        await Promise.all(promises)
        console.warn('INIT - cleanAllStorage - done')
        return true
    } catch (error) {
        console.error('Error al limpiar almacenamiento:', error)
        return false
    }
}
